// Common Components
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
// Services
import { getForbiddenConstraintTable } from "src/Requests/portfolioGroups";
// Types
import type {
  IForbiddenConstraintSearchParams,
  IForbiddenConstraintTableReport,
} from "src/Interfaces/portfolioGroups";

const LimitsModal = () => {
  return (
    <div>
      <TableTemplate<
        IForbiddenConstraintSearchParams,
        IForbiddenConstraintTableReport
      >
        getDataTable={getForbiddenConstraintTable}
        TableUI={({ reports, sortingType, setSortingType, onAction }) => (
          <CommonTableUI
            reports={reports}
            onAction={onAction}
            sortingType={sortingType}
            setSortingType={setSortingType}
            tableBoxClassName="!mx-0"
          />
        )}
        withSort
      />
    </div>
  );
};

export default LimitsModal;
